<template>
    <div class="vm-more-action" @click="tap">
        ···
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default(){
              return this.$t('c.MoreAction.text1')
            },
        },
        text: {
            type: String,
            default(){
              return this.$t('c.MoreAction.text2')
            },
        },
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {
        tap() {
            // let re = confirm(this.title)
            // if(re){
            //     alert(this.text)
            // }
            this.$notify({
                title: this.$t('c.MoreAction.text2'),
                group: "error",
            });
        },
    },
};
</script>

<style lang="stylus" scoped>
.vm-more-action{


}
</style>
